import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-testimonial-failure',
  templateUrl: './testimonial-failure.component.html',
  styleUrls: ['./testimonial-failure.component.scss']
})
export class TestimonialFailureComponent implements OnInit {

 constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }
}
